import {CaretIcon} from '../../atoms/Icons/CaretIcon';
import FlexWrapper from '../shared/FlexWrapper';
import {Link} from 'gatsby';
import React from 'react';
import {NavDropdown, NavDropdownItem} from './NavDropdown';
import ReactMarkdown from 'react-markdown';

const NavLinks = ({navbarLinks, variant}) => (
    <div className="center-links">
      {
        navbarLinks.map((navbarLink, idx) => (
            <div key={idx}>
              {
                navbarLink.children && navbarLink.children.length ?
                    <NavDropdown variant={variant}>
                      <button className="nav-dropdown-trigger">
                        <span>{navbarLink.title}</span>
                        <CaretIcon/>
                      </button>
                      <div className="nav-dropdown-items-wrapper">
                        <FlexWrapper className="nav-dropdown-items" column align="flex-start">
                          {
                            navbarLink.children.map((child, idx) => (
                                <a href={child.link} key={idx}>
                                  <NavDropdownItem color={child.color}>
                                    <p className="title">{child.title}</p>
                                    {
                                      child.description ?
                                          <ReactMarkdown className="description" source={child.description}/> :
                                          null
                                    }
                                  </NavDropdownItem>
                                </a>
                            ))
                          }
                        </FlexWrapper>
                      </div>
                    </NavDropdown>
                    : <a className="nav-link" href={navbarLink.link}>{navbarLink.title}</a>
              }
            </div>
        ))
      }
    </div>
);

export {NavLinks};
